export default __webpack_public_path__ + "statistics-section.png";